import store from "@/store";

const routes = [{
    path: "/operations/stockcards/:id",
    name: "warehousestockcard",
    component: () => import('@/views/main/modules/Operations/StockCards/StockCardGroupComponent'),
    beforeEnter: (to, from, next) => {
        store.dispatch('checkAccessUser', to.params.id).then((response) => {
            if (response == 'fail') {
                next('/no-access')
            } else {
                next()
            }
        }).catch(() => {

        })
    },
    meta: {
        requiresAuth: true,
        title: 'Stock Cards',
    }
}]

export default routes;
